import type { PageTemplateProps } from "./pageTemplateTypes";

/**
 * React translation of the old {@code checkoutConfirmationLayoutPage.jsp}.
 *
 * The JSP renders five CMS slots in order; the {@code BodyContent} position is
 * the body-bearing slot and is replaced by the route-selected order or quote
 * confirmation body, per the 0153 body-replacement decision for body-bearing
 * slot positions.
 *
 * Structure-copy parity: slot order (SideContent, TopContent, body at the
 * BodyContent position, FeedbackFormSlot, BottomContent) and the JSP wrapper
 * classes are preserved exactly because they affect runtime layout.
 */
export function CheckoutConfirmationPageTemplate({ slots, body }: PageTemplateProps) {
  return (
    <>
      <div className="checkoutPageSideContent">{slots.renderSlot("SideContent")}</div>
      <div className="checkoutPageTopContent">{slots.renderSlot("TopContent")}</div>
      <div className="checkout__confirmation__content">{body}</div>
      <div className="d-flex flex-direction-column flex-align-center">{slots.renderSlot("FeedbackFormSlot")}</div>
      <div className="checkoutPageBottomContent">{slots.renderSlot("BottomContent")}</div>
    </>
  );
}
